import { takeEvery, call, put } from 'typed-redux-saga'
import { errorHandler } from 'Modules'
import { Deserialize } from 'cerialize'
import { ResponseCatalog } from 'Models'
import {
	UnblockRequestStatusModel,
	unblockRequestStatusesApi,
	UnblockRequestStatusNS,
	unblockRequestStatusSlice,
} from 'Pages/orders'

function* getAll(action: UnblockRequestStatusNS.GetAll) {
	try {
		const res = yield* call(unblockRequestStatusesApi.getAll, action.payload.params)
		const entries = res.map(
			(unblockRequestStatus): UnblockRequestStatusModel =>
				Deserialize(unblockRequestStatus, UnblockRequestStatusModel)
		)
		const unblockRequestStatuses = new ResponseCatalog<UnblockRequestStatusModel>({
			current_page: 1,
			per_page: 1000,
			total_entries: entries.length,
			entries,
		})
		yield* put(unblockRequestStatusSlice.actions.setAll(unblockRequestStatuses))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export const unblockRequestStatusSaga = function* saga() {
	yield* takeEvery(unblockRequestStatusSlice.actions.getAll.type, getAll)
}
